import {Text, View, Image} from '@react-pdf/renderer';
import * as JsBarcode from "jsbarcode";
import {getPrimaryBrandColor} from "../../utils/themePdfUtils";

export function BarCode(props) {
    const canvas = document.createElement('canvas')
    JsBarcode(canvas, props.number);
    const barcode = canvas.toDataURL();

    return <Image src={barcode} style={{width: "25%", height: "50px"}} />;
}

export function Box(props) {
    // TODO - check if this color is the correct one: d2c1b1 in the style guides it's d0bfb0
    return (
        <View style={{padding: "6px 12px", border: "1px solid #d2c1b1", marginTop: "8px", ...props.style}}>
            {props.children}
        </View>
    )
}

export function BottomBorderBox(props) {
    return (
        <View style={{
            marginTop: "8px",
            paddingBottom: "8px",
            borderBottom: `1px solid ${getPrimaryBrandColor()}`,
        }}>
            {props.children}
        </View>
    )
}

export function Columns(props) {
    return (
        <View style={{
            display: "flex",
            flexDirection: "row",
        }}>
            {props.children}
        </View>
    )
}

export function Column(props) {
    return (
        <View style={{
            flex: 1,
        }}>
            {props.children}
        </View>
    )
}

export function Title(props) {
    return (
        <Text style={{fontSize: "12px", color: getPrimaryBrandColor(), fontWeight: "bold"}}>
            {props.children}
        </Text>
    )
}

export function LabeledText(props) {
    return (
        <Text style={{margin: "4px 0", ...props.style}}>
            <Text style={{fontWeight: "bold"}}>
                {props.label}:
            </Text>
            <Text>
                {' '}{props.value}
            </Text>
        </Text>
    )
}

export function CFCLabeledText(props) {
    return (
        <View style={{margin: "3px 0", ...props.style}}>
            <Text style={{fontWeight: "bold", textTransform: "uppercase", color: getPrimaryBrandColor()}}>
                {props.label}:
            </Text>
            <Text>
                {props.value}
            </Text>
        </View>
    )
}